import { KAPLAYCtx } from "kaplay";
import { HUD_TOP_Y, SHAFT_CENTER_X, SHAFT_LEFT, SHAFT_RIGHT } from "../../constants";
// import { COLORS } from "../../colors";
// import { isPrimary, MIX_RECIPES } from "../../rules/colorMixing";
import { PALETTE, textStyle } from "../../theme";
// import { GameColor } from "../../types";

const COMBO_POP_SCALE = 1.25;
// const COLOR_PANEL_Y = 785;

// function describeColor(color: GameColor): string {
//     const name = COLORS[color].name;
//     if (isPrimary(color)) return `COLOR: ${name} (PRIMARY)`;
//     const [first, second] = MIX_RECIPES[color].map((c) => COLORS[c].name);
//     return `COLOR: ${name} (${first} + ${second})`;
// }

/** Score, combo and best along the top; the active-colour panel above the buttons. */
export function createHud(k: KAPLAYCtx, highScore: number) {
    const scoreLabel = k.add([
        k.text("SCORE: 0", textStyle(18)),
        k.pos(SHAFT_LEFT, HUD_TOP_Y),
        k.color(...PALETTE.white),
        k.z(10),
    ]);

    const comboLabel = k.add([
        k.text("COMBO x1", textStyle(18)),
        k.pos(SHAFT_CENTER_X, HUD_TOP_Y),
        k.anchor("center"),
        k.color(...PALETTE.mutedText),
        k.scale(1),
        k.z(10),
    ]);

    k.add([
        k.text(`BEST: ${highScore}`, textStyle(15)),
        k.pos(SHAFT_RIGHT, HUD_TOP_Y),
        k.anchor("topright"),
        k.color(...PALETTE.gold),
        k.z(10),
    ]);

    // k.add([
    //     k.rect(SHAFT_WIDTH, 44, { radius: 8 }),
    //     k.pos(SHAFT_LEFT, COLOR_PANEL_Y),
    //     k.color(20, 24, 38),
    //     k.outline(1, k.rgb(55, 65, 95)),
    //     k.z(15),
    // ]);

    // const colorSwatch = k.add([
    //     k.rect(26, 26, { radius: 4 }),
    //     k.pos(SHAFT_LEFT + 22, COLOR_PANEL_Y + 22),
    //     k.anchor("center"),
    //     k.color(...COLORS[initialColor].rgb),
    //     k.outline(2, k.rgb(...PALETTE.white)),
    //     k.z(16),
    // ]);

    // const colorLabel = k.add([
    //     k.text(describeColor(initialColor), textStyle(14)),
    //     k.pos(SHAFT_LEFT + 45, COLOR_PANEL_Y + 15),
    //     k.color(...PALETTE.white),
    //     k.z(16),
    // ]);

    // k.add([
    //     k.text("Double-tap to reset", textStyle(11)),
    //     k.pos(SHAFT_RIGHT - 14, COLOR_PANEL_Y + 17),
    //     k.anchor("topright"),
    //     k.color(140, 150, 175),
    //     k.z(16),
    // ]);

    return {
        setScore(score: number) {
            scoreLabel.text = `SCORE: ${Math.floor(score).toLocaleString()}`;
        },
        /** A combo above 1 is highlighted and pops; resetting to 1 just greys it out. */
        setCombo(combo: number) {
            comboLabel.text = `COMBO x${combo}`;
            comboLabel.color = k.rgb(...(combo > 1 ? PALETTE.gold : PALETTE.mutedText));
            if (combo > 1) comboLabel.scale = k.vec2(COMBO_POP_SCALE);
        },
        // setColor(color: GameColor) {
            // const rgb = k.rgb(...COLORS[color].rgb);
            // colorSwatch.color = rgb;
            // colorLabel.color = rgb;
            // colorLabel.text = describeColor(color);
        // },
        easeBack(dt: number) {
            comboLabel.scale = k.vec2(k.lerp(comboLabel.scale.x, 1, dt * 8));
        },
    };
}
